<template>
  <div class="app-loader">
    <div class="spinner"></div>
    <span>{{ text || $t('loading') }}</span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    text: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
.app-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #7e8299;
}
.app-loader .spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--kt-primary, #0b3d87);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: app-loader-spin 1s linear infinite;
  margin-bottom: 16px;
}
@keyframes app-loader-spin {
  to { transform: rotate(360deg); }
}
</style>
